import { createReturnsNotification } from './utils';

const FEATURE_NAME = 'returns_notification_pdp';

const ReturnsNotificationPdp = createReturnsNotification(FEATURE_NAME);

export default ReturnsNotificationPdp;
